<template>
    <div class="row">
        <div class="col-12 col-md-12 col-lg-4 offset-md-0 mt-0">
            <div class="visible-md visible-lg">
            <span class="title-title">Rechtsanwalt</span><span class="title"> Christ</span>
            </div>
            <p class="mt-5">Der oberste Grundsatz meiner Arbeit ist: Für das Mandat nehme ich mir die Zeit, die für eine umfassende Bearbeitung erforderlich ist.</p>
        </div>
        <div class="col-12 col-md-12 col-lg-6 offset-lg-2 mt-sm-2 pt-sm-2 mt-md-5 pt-md-5 mt-lg-5 pt-lg-5">
            <div class="row mt-5 pt-5 visible-lg"></div>
            <div class="row mt-2 pt-2 visible-xs"></div>
            <p class="title">Ihr Rechtsanwalt in Bochum-Ehrenfeld</p>
            <div class="row pl-1">
                <div class="col-md-6">
                    <p class="mt-md-5 mt-lg-5">Meine Schwerpunkte sind:</p>
                    <ul class="fields-of-law">
                        <li><a @click.prevent="$emit('routeTo', 'lot')" href="#">Mietrecht</a></li>
                        <li><a @click.prevent="$emit('routeTo', 'fl')" href="#">Familienrecht</a></li>
                        <li><a @click.prevent="$emit('routeTo', 'cl')" href="#">Strafrecht</a></li>
                    </ul>
                    <br class="visible-xs"/>
                    <br class="visible-xs"/>
                    <p class="center-sm"><b>Tel: </b><a class="pl-7px" href="tel:023441482604"><b>0234 414 826-04</b></a></p>
                    <p class="center-sm"><b>Fax: 0234 414 826-05</b></p>
                    <p class="center-sm">Hattinger Straße 57</p>
                    <p class="center-sm">44789 Bochum</p>
                </div>
                <div class="d-none d-md-block col-md-5 offset-md-1 offset-lg-0">
                    <div class="mt-5"></div>
                    <img alt="Rechtsanwalt Christ" src="../assets/portrait-rechtsanwalt-christ.jpg">
                </div>
            </div>

        </div>
        <div class="col-12 col-sm-6 col-md-4 offset-md-0">

        </div>

    </div>
</template>

<script>

    export default {
        name: "Home.vue",

    }
</script>

<style scoped>

</style>